@for (sentiment of sentimentPercentages(); track $index) {
  <div
    [matTooltip]="sentiment.tooltip"
    class="sentiment-bar__bar"
    [style.width]="sentiment.percentage + '%'"
    [style.background-color]="sentiment.color"
  ></div>
}
